import { joinURL } from 'ufo'
import { defineProvider, createOperationsGenerator } from '@nuxt/image/runtime'

const operationsGenerator = createOperationsGenerator()

export default defineProvider<{ baseURL?: string }>({
  getImage(src, { modifiers, baseURL }) {
    if (!baseURL) {
      baseURL = ''
    }
    const operations = operationsGenerator(modifiers)
    return {
      url: joinURL(baseURL, src + (operations ? '?' + operations : '')),
    }
  }
})
